module.exports = __webpack_public_path__ + "img/cps_preview_it.d074093d.png";